export enum LoginNameEnum {
  PARTICIPE = 'Participe',
  ACESSO_CIDADAO = 'AcessoCidadao'
}

export enum AuthenticationTypeEnum {
  CPF = 'participeCpf',
  EMAIL = 'participeEmail',
  OAUTH = 'oauth'
}
